import { ApiDimension } from "@incendium/api";
import GlassCard from "Components/GlassCard/GlassCard";
import {
  AnalyticsFilterDropdown,
  useFilterableDimensions,
} from "features/analytics";
import {
  PRODUCT_PERFORMANCE_TABS,
  ProductPerformanceTab,
} from "features/products/utils/productPerformanceTabs";
import { ProductPerformanceFilters } from "features/products/utils/productPerformanceFilters";
import { Stack, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

interface ProductPerformanceFilterBarProps {
  filters: ProductPerformanceFilters;
  onChange: (filters: ProductPerformanceFilters) => void;
  tab: ProductPerformanceTab;
  onTabChange: (tab: ProductPerformanceTab) => void;
}

function ProductPerformanceFilterBar({
  filters,
  onChange,
  tab,
  onTabChange,
}: ProductPerformanceFilterBarProps) {
  useFilterableDimensions();

  return (
    <GlassCard boxProps={{ p: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
      >
        <ToggleButtonGroup
          size="small"
          value={tab}
          exclusive
          color="secondary"
          onChange={(_, value: ProductPerformanceTab | null) => {
            if (value) {
              onTabChange(value);
            }
          }}
        >
          {(Object.keys(PRODUCT_PERFORMANCE_TABS) as ProductPerformanceTab[]).map(
            (key) => (
              <Tooltip
                key={key}
                title={PRODUCT_PERFORMANCE_TABS[key].tabTooltip}
                arrow
                placement="top"
                slotProps={{
                  tooltip: {
                    sx: { maxWidth: 280, textAlign: "center" },
                  },
                }}
              >
                <ToggleButton value={key}>
                  {PRODUCT_PERFORMANCE_TABS[key].label}
                </ToggleButton>
              </Tooltip>
            ),
          )}
        </ToggleButtonGroup>

        <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
          <AnalyticsFilterDropdown
            dimension={ApiDimension.DIMENSION_PRODUCT_CATEGORY}
            label="Category"
            blankLabel="All Categories"
            maxWidth={300}
            onChange={(category) => onChange({ ...filters, category })}
          />
          <AnalyticsFilterDropdown
            dimension={ApiDimension.DIMENSION_PRODUCT_BRAND}
            label="Brand"
            blankLabel="All Brands"
            maxWidth={300}
            onChange={(brand) => onChange({ ...filters, brand })}
          />
        </Stack>
      </Stack>
    </GlassCard>
  );
}

export default ProductPerformanceFilterBar;
